import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { PostPlatformV1UsersBody } from '@nucleus-commerce/api-client/platform';

import { usersApi } from '../api/users-api';

import { userKeys } from './user-keys';

/** POST /platform/v1/users: the account exists at once, the person gets a 7-day set-password link. */
export function useCreateUser() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: PostPlatformV1UsersBody) => usersApi.create(input),
    meta: { successMessage: 'users:toasts.created', silentError: true },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: userKeys.list() }),
  });
}
